import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiRouteConstants } from '../../../../../../core/constants/api-routes';
import { FileTypeConstants } from '../../../../../../core/constants/file-type-constants';
import { OrderStatusUpdateRequest } from '../../../../../../shared/components/grid/cell-renderers/order-fulfillment/order-status-cell-renderer/models/order-status-update-request';
import { CustomerOrderDashboardGridResponse } from '../../../customer-order-dashboard/models/customer-order-dashboard-grid-response';
import { OrderDetailsResponse } from '../../../order-details/models/order-details-response';
import { SaveOrderRequest } from '../../../order-details/models/save-order-request';
import { SetPreferredPaymentMethodRequest } from '../../../order-details/models/set-preferred-payment-method-request';
import { OrderStaffGridResponse } from '../../../order-fulfillment/models/order-staff-grid-response';

@Injectable({
    providedIn: 'root',
})
export class OrderService {
    private readonly http = inject(HttpClient);
    private readonly orderApiRoute = ApiRouteConstants.Order;

    get(id: string): Observable<OrderDetailsResponse> {
        return this.http.get<OrderDetailsResponse>(
            this.orderApiRoute.getByIdUrl(id),
        );
    }

    getAll(): Observable<OrderStaffGridResponse[]> {
        return this.http.get<OrderStaffGridResponse[]>(
            this.orderApiRoute.getRootUrl(),
        );
    }

    save(orderId: string, request: SaveOrderRequest): Observable<void> {
        return this.http.post<void>(
            this.orderApiRoute.getByIdUrl(orderId),
            request,
        );
    }

    updateOrderStatus(
        orderId: string,
        request: OrderStatusUpdateRequest,
    ): Observable<void> {
        return this.http.patch<void>(
            this.orderApiRoute.getUpdateStatusUrl(orderId),
            request,
        );
    }

    getAllForCustomer(
        userId: number,
    ): Observable<CustomerOrderDashboardGridResponse[]> {
        return this.http.get<CustomerOrderDashboardGridResponse[]>(
            this.orderApiRoute.getUserOrdersUrl(userId),
        );
    }

    setPreferredPaymentMethod(
        orderId: string,
        request: SetPreferredPaymentMethodRequest,
    ): Observable<void> {
        return this.http.post<void>(
            this.orderApiRoute.getSetPreferredPaymentMethodUrl(orderId),
            request,
        );
    }

    getBillingDocumentPdf(orderId: string): Observable<Blob> {
        const headers = new HttpHeaders({ Accept: FileTypeConstants.PDF });

        return this.http.get(
            this.orderApiRoute.getBillingDocumentPdfUrl(orderId),
            {
                headers,
                responseType: 'blob',
            },
        );
    }

    sendInvoice(orderId: string): Observable<void> {
        return this.http.post<void>(
            this.orderApiRoute.sendInvoiceUrl(orderId),
            {},
        );
    }
}
